import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import {
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
} from '@material-ui/core';

import CalendarToday from '@material-ui/icons/CalendarToday';
import FormatListBulleted from '@material-ui/icons/FormatListBulleted';
import CakeIcon from '@material-ui/icons/Cake';
import PersonIcon from '@material-ui/icons/Person';

import { makeStyles } from '@material-ui/core/styles';

import configs from '../../configs';

const sitemaps = [
	{ label: 'Calendar', value: 'CALENDAR', pathname: '/calendar', icon: CalendarToday },
	{ label: 'Events', value: 'EVENTS', pathname: '/events', icon: FormatListBulleted },
	{ label: 'Birthdates', value: 'BIRTHDATES', pathname: '/birthdates', icon: CakeIcon },
	{ label: 'Profile', value: 'PROFILE', pathname: '/profile', icon: PersonIcon },
];

const useStyles = makeStyles(theme => ({
	agency: {
		color: theme.palette.primary.main,
		margin: 0,
		fontWeight: 600,
	},
	toolbar: {
		...theme.mixins.toolbar,
		padding: 10,
		paddingLeft: 16,
	},
	innerList: {
		paddingLeft: 30,
		transition: 'all 0.3s',
	},
	active: {
		color: theme.palette.primary.main,
		borderRight: `3px solid ${theme.palette.primary.light}`,
	},
}));

function Drawer({ onClose }) {
	const classes = useStyles();

	return (
		<Fragment>
			<div className={classes.toolbar}>
				<p className={classes.agency}>{configs.name}</p>
			</div>
			<Divider />
			<List>
				{sitemaps.map((e) => (
					<ListItem 
						className={classes.innerList} 
						activeClassName={clsx(
							classes.active,
						)}
						key={e.value} 
						component={NavLink} 
						to={e.pathname} 
						dense 
						button
					>
						<ListItemIcon>
							<e.icon />
						</ListItemIcon>
						<ListItemText primary={e.label} />
					</ListItem>
				))}
			</List>
			
			<div style={{ flex: 1 }}/>
		</Fragment>
	);
}

export default Drawer;
